import React , { useContext } from 'react';
import UserProvider from '../../context/UserContext';

export const CardHowItWorks = () => {
    
    const Context = useContext(UserProvider.context);

    const handleShowHowItWorks = () => {
        Context.setshowHowItWorks(!Context.showHowItWorks)
    }
        
    return(
        <div className="card-component howitworks-card">
            <div className="card-content">
                <div className="howitworks-handle">
                    <h2 className="howitworks-title">How it works?</h2>
                    <div className="howitworks-text-handle">
                        <h4 className="howitworks-text">1. Join our waitlist using your main Discord account</h4>
                        <h4 className="howitworks-text">2. Receive an email if your account gets selected</h4>
                        <h4 className="howitworks-text">3. Destroy raffles with Infinit’s power</h4>
                    </div>
                    <div className="close-button-holder">
                        <button className="close-button" onClick={handleShowHowItWorks}>Close</button>
                    </div>
                </div>
            </div>
        </div>
    )

};